module.exports = __webpack_public_path__ + "static/media/altre-strutture-audio-noleggiocampi.4960509b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/extra/audio/altre-strutture-audio-noleggiocampi.jpg
// module id = 628
// module chunks = 0